import { AppShellRoot } from './app-shell-root';
import { AppShellIconRail, AppShellIconRailItem } from './icon-rail';
import { AppShellSecondaryNav } from './secondary-nav';
import { AppShellMain } from './main';

export const AppShell = {
  Root: AppShellRoot,
  IconRail: AppShellIconRail,
  IconRailItem: AppShellIconRailItem,
  SecondaryNav: AppShellSecondaryNav,
  Main: AppShellMain,
};

export type { AppShellRootProps } from './app-shell-root';
export type { AppShellIconRailProps, AppShellIconRailItemProps } from './icon-rail';
export type { AppShellSecondaryNavProps } from './secondary-nav';
export type { AppShellMainProps } from './main';
